var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1140,
    height: 600,
    viewBox: "0 0 209 110",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h209v110H0z",
    fill: "#bf0a30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15h209m0 20H0",
    stroke: "#fff",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v55H0z",
    fill: "#002868"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 55h209m0 20H0m0 20h209",
    stroke: "#fff",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15 0 0 15 25 25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#fff",
    transform: "rotate(18 3.157 -.5)",
    d: "M0 0v1h.5z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(216)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLr);
export default __webpack_public_path__ + "static/media/lr.0e9ea45861842c9586bdec22db5d9103.svg";
export { ForwardRef as ReactComponent };